var _path, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategoryVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 35,
    viewBox: "0 0 54 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66171 6.30131C0.571777 8.44043 0.571777 11.2407 0.571777 16.8412V18.8411C0.571777 24.4416 0.571777 27.2418 1.66171 29.381C2.62045 31.2626 4.15025 32.7924 6.03187 33.7511C8.17099 34.8411 10.9713 34.8411 16.5718 34.8411H23.4287C29.0293 34.8411 31.8295 34.8411 33.9686 33.7511C35.8503 32.7924 37.3801 31.2626 38.3388 29.381C39.1448 27.7991 39.3548 25.8556 39.4095 22.6855L46.2265 27.2302C49.5493 29.4453 54 27.0634 54 23.0699V12.6124C54 8.61888 49.5493 6.23691 46.2265 8.4521L39.4095 12.9968C39.3548 9.82666 39.1448 7.88321 38.3388 6.30131C37.3801 4.41969 35.8503 2.88989 33.9686 1.93115C31.8295 0.841217 29.0293 0.841217 23.4287 0.841217H16.5718C10.9713 0.841217 8.17099 0.841217 6.03187 1.93115C4.15025 2.88989 2.62045 4.41969 1.66171 6.30131Z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5961,
    cy: 10.0428,
    r: 3.46748,
    fill: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5961,
    cy: 10.0428,
    r: 3.46748,
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryVideo);
export default __webpack_public_path__ + "react/media/category-video.93c5ea5fe0ba166d1b0f8f6e9bfe6e8c.svg";
export { ForwardRef as ReactComponent };